module.exports = __webpack_public_path__ + "static/img/YM@3x.8fe8c049.jpg";